import axios from 'axios';

//const API_URL = 'http://localhost:8080/api/auth/';

//class AuthService {
const AuthService = {
  login(user) {
    console.log('login AuthService');
    return axios
      .post('/api/signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        console.log(response);
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  },

  logout() {
    localStorage.removeItem('user');
  },

  register(user) {
    return axios.post('/api/signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

//export default new AuthService();
export default {
  namespaced: true,
  AuthService
}